import SettingOverride from "@app.raytd.com/common/types/setting-override";
import { TestSuiteType } from "@app.raytd.com/common/types/test-suite-types";
import FieldDefaults from "@app.raytd.com/common/types/field-defaults";
import { translateFieldName } from "./translateFieldName";
import { getDefaultFieldSettings } from "@app.raytd.com/common/utils/test-suites/getDefaultFieldSettings";

export const getFieldSetting = (
    fieldName: string,
    testSuiteType: TestSuiteType,
    settings: SettingOverride[]
  ): FieldDefaults => {
    const translatedFieldName = translateFieldName(fieldName);
    const defaultSettings = getDefaultFieldSettings(translatedFieldName, testSuiteType);
    const settingOverride = settings.find((s) => s.field_name === translatedFieldName);
  
    return {
      active: settingOverride?.active ?? defaultSettings.active,
      required: settingOverride?.required ?? defaultSettings.required,
    };
  };